import { createRef } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
// import Welcome from "./Components/Welcome.jsx";
// import GreetComponent from "./Components/GreetComponent.jsx";



// import VDatePicker4b from "./mycomps/VDatePicker4b.jsx";
import BookingDateSection3 from "./mycomps/BookingDateSection3.jsx";
import JourneyList from "./JourneyList/JourneyList.jsx";
import MobileAppBookingDateSection from "./mycomps/MobileAppBookingDateSection.jsx";
import CommonSearchDateSection from "./mycomps/CommonSearchDateSection.jsx";
import RainCanvas from "./SeasonComponents/RainCanvas.jsx";
import PromoModal from "./PramotionalComponents/CarouselModalPopup.jsx";

// web components

// class WelcomeComponent extends HTMLElement {
//   connectedCallback() {
//     const mount = document.createElement("div");
//     this.appendChild(mount);
//     createRoot(mount).render(<Welcome />);
//   }
// }
// customElements.define("welcome-component", WelcomeComponent);

// class GreetWidget extends HTMLElement {
//   connectedCallback() {
//     const name = this.getAttribute("name") || "Guest";
//     const mount = document.createElement("div");
//     this.appendChild(mount);
//     createRoot(mount).render(<GreetComponent name={name} />);
//   }
// }
// customElements.define("greet-component", GreetWidget);

// class VTestDatePickerWidget extends HTMLElement {
//   connectedCallback() {
//     const config = JSON.parse(this.getAttribute("config") || "{}");
//     const targetId = this.getAttribute("target");
//     const targetElement = document.getElementById(targetId);
//     const type = this.getAttribute("type");

//     if (!targetElement) {
//       console.error(`Target element with ID "${targetId}" not found.`);
//       return;
//     }

//     const mount = document.createElement("div");
//     this.appendChild(mount);

//     const inputRef = createRef();
//     inputRef.current = targetElement;

//     createRoot(mount).render(
//       <VDatePicker4b
//         targetRef={inputRef}
//         config={config}
//         onDateSelect={(date) => {
//           if (type == "input") {
//             inputRef.current.value = date;
//             inputRef.current.style.backgroundColor = "#e6f7ff";
//           } else {
//             inputRef.current.innerHTML = date;
//             inputRef.current.style.backgroundColor = "#e6f7ff";
//           }
//         }}
//       />
//     );
//   }
// }

// customElements.define("date-picker2", VTestDatePickerWidget);

// class DatePickerWidget extends HTMLElement {
//   connectedCallback() {
//     const mount = document.createElement("div");
//     this.appendChild(mount);

//     // Parse attributes
//     const value = this.getAttribute("value") || "";
//     const placeholder = this.getAttribute("placeholder") || "Select Date";
//     const minDate = new Date(this.getAttribute("minDate"));
//     const maxDate = new Date(this.getAttribute("maxDate"));
//     const locale = this.getAttribute("locale") || "en-IN";

//     // Handle dateFormat
//     const formatType = this.getAttribute("dateFormat");
//     let dateFormat = (dt) => dt.toLocaleDateString(locale);
//     if (formatType === "iso") {
//       dateFormat = (dt) => dt.toISOString().slice(0, 10);
//     }

//     // Resolve onChange callback
//     const onChangeAttr = this.getAttribute("onChange");
//     const onChangeCallback =
//       typeof window[onChangeAttr] === "function"
//         ? window[onChangeAttr]
//         : () => {};

//     createRoot(mount).render(
//       <VDatePicker4b
//         value={value}
//         onChange={onChangeCallback}
//         placeholder={placeholder}
//         minDate={minDate}
//         maxDate={maxDate}
//         dateFormat={dateFormat}
//       />
//     );
//   }
// }

// customElements.define("date-picker", DatePickerWidget);

class BookingSectionWidget extends HTMLElement {
  connectedCallback() {
    const mount = document.createElement("div");
    this.appendChild(mount);

    // Parse attributes
    const configData = this.getAttribute("data-config") || "";
    // console.log(configData);
    const config = configData ? JSON.parse(configData) : null;
   // console.log(config);

    const urldata = this.getAttribute("data-bookingpageurl") || null;
   // console.log(urldata);

    const citiesDataUrl = this.getAttribute("data-citiesDataUrl") || null;
    
    const containerId = this.getAttribute("data-containerId") || null;
   // console.log(citiesDataUrl);

    const onChageDestinationConfigUrl =
      this.getAttribute("data-onchage-destination-config-url") || null;
   // console.log(onChageDestinationConfigUrl);

    createRoot(mount).render(
      <BookingDateSection3
        config={config}
        BookingPageUrl={urldata}
        citiesDataUrl={citiesDataUrl}
        onChangeDestinationConfigUrl={onChageDestinationConfigUrl}
        containerId={containerId}
      />
    );
  }
}
customElements.define("booking-section", BookingSectionWidget);

class RouteSearchDataWidget extends HTMLElement {
  connectedCallback() {
    // const name = this.getAttribute('name') || 'Guest';
    
    // Parse attributes
    this.routeapiData = this.getAttribute("data-routeapi") || "";
   // console.log(routeapiData);

   // Parse attributes
    this.routeReturnapi = this.getAttribute("data-routeReturnapi") || "";


    this.paymentUrl = this.getAttribute("data-paymentUrl") || "";
   // console.log(paymentUrl);

    this.citiesDataUrl = this.getAttribute("data-citiesDataUrl") || null;
   // console.log(citiesDataUrl);

    this.bookingPageUrl = this.getAttribute("data-bookingPageUrl") || null;
  //  console.log(bookingPageUrl);
    this.layoutUrl = this.getAttribute("data-layouturl") || null;
  //  console.log(layoutUrl);


    this.journeySeatsInfo = this.getAttribute("data-journeySeatsInfo") || null;
   // console.log(journeySeatsInfo);


    this.bookSeatsTempEndPoint = this.getAttribute("data-bookSeatsTempEndPoint") || null;
  //  console.log(bookSeatsTempEndPoint);


   this.defaultCalendarConfigApi = this.getAttribute("data-defaultCalendarConfigApi") || null;
   //console.log(defaultCalendarConfigApi);


   this.onchangeDestChangeCalendarConfigApi = this.getAttribute("data-onchangeDestChangeCalendarConfigApi") || null;
   //console.log(onchangeDestChangeCalendarConfigApi);


    this.ServerBaseUrl = this.getAttribute("data-serverBaseUrl") || null;
  //  console.log(ServerBaseUrl);


    this.LocalwebUrl = this.getAttribute("data-localwebUrl") || null;

    this.redirectToPg = this.getAttribute("data-redirectToPg") || null;
   
   
    this.modifyAutoSearch = this.getAttribute("data-modifyAutoSearch") || null;
    this.alterSeatBookingInfo = this.getAttribute("data-alterSeatBookingInfo") || null;
    this.postponeOrpreponeResultUrl = this.getAttribute("data-postponeOrpreponeResultUrl") || null;




    //console.log(redirectToPg);

    const mount = document.createElement("div");
    this._root = createRoot(mount);
    this.appendChild(mount);


   // These Changes are for userloged In information

  //  console.log('AppEvents exists?', !!window.AppEvents);      // should be true
  //  console.log('APP_STATE exists?', !!window.__APP_STATE__);


    this.user = window.__APP_STATE__?.user || null;

    console.log("It is from JL component:window.__APP_STATE__?.user")
    console.log(this.user);

    this._onUserChanged = (updatedUser) => {
          console.log("It is from JL component:_onUserChanged")
          console.log(updatedUser)
          this.user ={IsPassengerSignedIn: updatedUser !=null ? 1 : 0, SignedPassenger:updatedUser} ;
          this._render();
        };
    window.AppEvents.on('userChanged', this._onUserChanged);

    this._render();
  }


  disconnectedCallback() {
        // Always unsubscribe to avoid memory leaks
        window.AppEvents.off('userChanged', this._onUserChanged);
  }





  _render() {
    this._root.render(
        <JourneyList

        
        routeapi={this.routeapiData}
        routeReturnapi={this.routeReturnapi} 
        citiesDataUrl={this.citiesDataUrl}
        paymentUrl={this.paymentUrl}
        bookingPageUrl={this.bookingPageUrl} 
        layouturl={this.layoutUrl} 
        journeySeatsInfo={this.journeySeatsInfo} 
        BookSeatsTempEndPoint={this.bookSeatsTempEndPoint}
        ServerBaseUrl={this.ServerBaseUrl}
        LocalwebUrl={this.LocalwebUrl}
        redirectToPg = {this.redirectToPg} 
        modifyAutoSearch = {this.modifyAutoSearch}
        alterSeatBookingInfo = {this.alterSeatBookingInfo}
        postponeOrpreponeResultUrl={this.postponeOrpreponeResultUrl}

        defaultCalendarConfigApi ={this.defaultCalendarConfigApi}
        onchangeDestChangeCalendarConfigApi = {this.onchangeDestChangeCalendarConfigApi}
        SignedPassenger = {this.user}
        
      />
    );
  }
}
customElements.define("routesearch-section", RouteSearchDataWidget);







class MobileBookingSectionWidget extends HTMLElement {
  connectedCallback() {
    const mount = document.createElement("div");
    this.appendChild(mount);

    // Parse attributes
    const configData = this.getAttribute("data-config") || "";
    //console.log(configData);
    const config = configData ? JSON.parse(configData) : null;
  // console.log(config);

    const urldata = this.getAttribute("data-bookingpageurl") || null;
  // console.log(urldata);

    const citiesDataUrl = this.getAttribute("data-citiesDataUrl") || null;
   // console.log(citiesDataUrl);

    const onChageDestinationConfigUrl =
      this.getAttribute("data-onchage-destination-config-url") || null;
   // console.log(onChageDestinationConfigUrl);

    createRoot(mount).render(
      <MobileAppBookingDateSection
        config={config}
        BookingPageUrl={urldata}
        citiesDataUrl={citiesDataUrl}
        onChangeDestinationConfigUrl={onChageDestinationConfigUrl} 
      />
    );
  }
}
customElements.define("mobileappbooking-section", MobileBookingSectionWidget); 


class CommonBookingSectionWidget extends HTMLElement { 
  connectedCallback() {
    const mount = document.createElement("div");
    this.appendChild(mount);

    // Parse attributes
    const configData = this.getAttribute("data-config") || "";
    // console.log(configData);
    const config = configData ? JSON.parse(configData) : null;
   // console.log(config);

    const urldata = this.getAttribute("data-bookingpageurl") || null;
   // console.log(urldata);

    const citiesDataUrl = this.getAttribute("data-citiesDataUrl") || null;
    
    const containerId = this.getAttribute("data-containerId") || null;
    const autoSearch = this.getAttribute("data-autoSearch") || null; 
   // console.log(citiesDataUrl);

    const onChageDestinationConfigUrl =
      this.getAttribute("data-onchage-destination-config-url") || null;
   // console.log(onChageDestinationConfigUrl);

    createRoot(mount).render(
      <CommonSearchDateSection
        config={config}
        BookingPageUrl={urldata}
        citiesDataUrl={citiesDataUrl}
        onChangeDestinationConfigUrl={onChageDestinationConfigUrl}
        containerId={containerId}
        autoSearch={autoSearch} 
      />
    );
  }
}
customElements.define("commonbooking-section", CommonBookingSectionWidget);




class MonsoonRainElement extends HTMLElement {

  connectedCallback() {
    const mount = document.createElement("div");
    this.appendChild(mount);

  //   const onChageDestinationConfigUrl =
  //     this.getAttribute("data-onchage-destination-config-url") || null;
   // console.log(onChageDestinationConfigUrl);

    createRoot(mount).render(
      <RainCanvas/>
    );
  }
  

  disconnectedCallback() {
    // Unmount safely if the tag is ever removed from HTML DOM
    if (this.root) {
      this.root.unmount();
    }
  }
}
customElements.define("monsoon-rain", MonsoonRainElement);
// createRoot(document.getElementById('root')).render(

//     <App />
//  )




class ModalPopUpCarousel extends HTMLElement {

  connectedCallback() {
    const mount = document.createElement("div");
    this.appendChild(mount);

  //   const onChageDestinationConfigUrl =
  //     this.getAttribute("data-onchage-destination-config-url") || null;
   // console.log(onChageDestinationConfigUrl);

    createRoot(mount).render(
      <PromoModal/>
    );
  } 
  

  disconnectedCallback() {
    // Unmount safely if the tag is ever removed from HTML DOM
    if (this.root) {
      this.root.unmount();
    }
  } 
}
customElements.define("promo-popupcarousel", ModalPopUpCarousel);
